var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListErrorStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7089_707053",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 68.9108 118.054 77.3757 114.559 84.9811C105.089 105.649 84.2189 120 60 120C35.7811 120 14.9108 105.649 5.44054 84.9811C1.94595 77.3757 0 68.9108 0 60C0 26.8622 26.8622 0 60 0C93.1378 0 120 26.8622 120 60Z",
    fill: "#F4F7FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7089_707053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 84L22.5 79.875L39 86.25L24 94.5L2.625 84Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.375 84L97.5 79.875L81 86.25L96 94.5L117.375 84Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39 86.25H81L96 94.5H24L39 86.25Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0793 50.5798C51.8385 46.6773 60.4814 48.9932 64.3838 55.7524C68.2863 62.5115 65.9704 71.1545 59.2112 75.0569L51.2626 79.646L49.1291 89.2059C48.8661 90.3844 47.2924 90.6255 46.6887 89.5798L43.0171 83.2205C37.4837 83.9945 31.7809 81.424 28.8155 76.2878C24.9131 69.5286 27.229 60.8857 33.9882 56.9833L45.0793 50.5798Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2081,
    cy: 2.2081,
    r: 2.2081,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 54.8662 58.7017)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2081,
    cy: 2.2081,
    r: 2.2081,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 47.217 63.1196)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.2081,
    cy: 2.2081,
    r: 2.2081,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 39.568 67.5317)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7319 23.6854C58.716 21.0017 48.4209 26.9456 45.7371 36.9615C43.0534 46.9774 48.9973 57.2726 59.0132 59.9563L70.7932 63.1128L76.8182 74.647C77.5609 76.0689 79.6633 75.8372 80.0785 74.2876L82.6036 64.864C89.9703 63.9541 96.404 58.6946 98.4433 51.0841C101.127 41.0681 95.1831 30.773 85.1672 28.0892L68.7319 23.6854Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.039,
    cy: 41.0622,
    r: 2.93362,
    transform: "rotate(15 61.039 41.0622)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.3738,
    cy: 44.0973,
    r: 2.93362,
    transform: "rotate(15 72.3738 44.0973)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.7081,
    cy: 47.1384,
    r: 2.93362,
    transform: "rotate(15 83.7081 47.1384)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6951 32.7839C42.2994 32.6391 42.6718 32.0319 42.527 31.4277C42.3822 30.8234 41.775 30.451 41.1708 30.5958L38.2534 31.2949C37.6492 31.4397 37.2768 32.0469 37.4216 32.6511C37.5663 33.2553 38.1735 33.6278 38.7777 33.483L41.6951 32.7839ZM52.5122 19.092C52.5109 19.7133 52.0063 20.216 51.385 20.2148C50.7637 20.2136 50.261 19.7089 50.2622 19.0876L50.268 16.0876C50.2692 15.4663 50.7739 14.9636 51.3952 14.9648C52.0165 14.966 52.5192 15.4707 52.518 16.092L52.5122 19.092ZM43.1169 26.0355C42.9758 26.6405 42.3709 27.0167 41.7658 26.8756L38.8442 26.1942C38.2391 26.0531 37.863 25.4482 38.0041 24.8431C38.1452 24.2381 38.7501 23.8619 39.3552 24.003L42.2768 24.6844C42.8819 24.8255 43.258 25.4304 43.1169 26.0355ZM46.7835 20.5285C47.0607 21.0846 46.8345 21.76 46.2784 22.0372C45.7224 22.3143 45.0469 22.0882 44.7698 21.5321L43.4316 18.8471C43.1544 18.291 43.3805 17.6156 43.9366 17.3384C44.4927 17.0613 45.1682 17.2874 45.4453 17.8435L46.7835 20.5285Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 94.5,
    width: 72,
    height: 63,
    fill: "#DCDCDC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListErrorStateIcon);
export default __webpack_public_path__ + "static/media/list_error_state_icon.173ec5995098722fd26a5f0792e08c7f.svg";
export { ForwardRef as ReactComponent };